import { forwardRef, useEffect, useLayoutEffect, useState } from 'react';
import { Mixpanel } from '../../services/Mixpanel';

const MD_BREAKPOINT = 848;

export const HelperPills = forwardRef(({ pills, activePill, onPillClick }, ref) => {
  const [rowHeight, setRowHeight] = useState(null);

  useLayoutEffect(() => {
    const container = ref?.current;
    if (!container) return;

    const measure = () => {
      const firstBtn = container.querySelector('button');
      if (!firstBtn || window.innerWidth < MD_BREAKPOINT) {
        setRowHeight(null);
        return;
      }
      setRowHeight(Math.ceil(firstBtn.getBoundingClientRect().height));
    };

    const ro = new ResizeObserver(measure);
    ro.observe(container);
    return () => ro.disconnect();
  }, [ref, pills]);

  const pillIds = pills.map((p) => p.id).join(',');
  useEffect(() => {
    if (pills.length === 0) return;
    Mixpanel.track('Unlimited Helper Pills Displayed', {
      pill_ids: pills.map((p) => p.id),
      pill_labels: pills.map((p) => p.label),
      pill_count: pills.length,
    });
  }, [pillIds]);

  return (
    <div
      ref={ref}
      className='flex flex-wrap justify-center gap-3 px-4 mt-6 overflow-hidden'
      style={rowHeight ? { maxHeight: rowHeight } : undefined}>
      {pills.map((pill) => {
        const isActive = activePill === pill.id;
        return (
          <button
            key={pill.id}
            onClick={() => onPillClick(pill)}
            className={`text-base py-2 px-4 rounded-2xl border transition-colors ${
              isActive
                ? 'bg-gray-200 border-transparent text-gray-900 hover:bg-gray-300'
                : 'bg-gray-50 border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-300'
            }`}
            aria-pressed={isActive}>
            {pill.label}
          </button>
        );
      })}
    </div>
  );
});

HelperPills.displayName = 'HelperPills';
